export const ITEMS_PER_PAGE = 10;

export const TABLE_COLUMNS = {
  plan: { width: '10%' },
  group: { width: '10%' },
  order: { width: '5%' },
  subscriber: { width: '15%' },
  installmentDebtBalance: { width: '10%' },
  debtBalanceInPesos: { width: '10%' },
  lifeInsurance: { width: '10%' },
};

export const EXCEL_HEADERS = [
  'Plan',
  'Grupo',
  'Orden',
  'Suscriptor',
  'Saldo deuda cuota',
  'Cuota pura',
  'Saldo deuda pesos',
  'Seguro de vida',
];
